import {
  props,
  prop,
  entity,
  networkErrors,
  networkLoading,
  networkProps,
} from './utils'

const store = state => state.client
const collection = entity({
  baseSelector: prop(store, 'clients'),
  entityName: 'client',
})

const NETWORK_NAMES = networkProps('client', [
  'list',
  'get',
  'create',
  'save',
  'delete',
])

export default {
  store,
  errors: props(networkErrors, NETWORK_NAMES),
  loading: props(networkLoading, NETWORK_NAMES),
  collection,
}
